"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokens = void 0;
const assets_1 = require("./assets");
exports.tokens = {
    ETH: {
        symbol: 'ETH',
        name: 'Ethereum',
        decimals: 18,
        image: assets_1.ETHImage,
        coingeckoId: 'ethereum'
    },
    XDAI: {
        symbol: 'XDAI',
        name: 'XDAI',
        decimals: 18,
        image: assets_1.XDAIImage,
        coingeckoId: 'dai'
    },
    MATIC: {
        symbol: 'MATIC',
        name: 'Matic',
        decimals: 18,
        image: assets_1.MATICImage,
        coingeckoId: 'matic-network'
    },
    DAI: {
        symbol: 'DAI',
        name: 'DAI Stablecoin',
        decimals: 18,
        image: assets_1.DAIImage,
        coingeckoId: 'dai'
    },
    ARB: {
        symbol: 'ARB',
        name: 'Arbitrum',
        decimals: 18,
        image: assets_1.ARBmage,
        coingeckoId: 'arbitrum'
    },
    /*
    sETH: {
      symbol: 'sETH',
      name: 'Synth ETH',
      decimals: 18,
      image: sETHImage,
      coingeckoId: 'seth'
    },
    sBTC: {
      symbol: 'sBTC',
      name: 'Synth BTC',
      decimals: 18,
      image: sBTCImage,
      coingeckoId: 'sbtc'
    },
    */
    USDC: {
        symbol: 'USDC',
        name: 'USD Coin',
        decimals: 6,
        image: assets_1.USDCImage,
        coingeckoId: 'usd-coin'
    },
    USDT: {
        symbol: 'USDT',
        name: 'Tether USD',
        decimals: 6,
        image: assets_1.USDTImage,
        coingeckoId: 'tether'
    },
    WBTC: {
        symbol: 'WBTC',
        name: 'Wrapped BTC',
        decimals: 8,
        image: assets_1.WBTCImage,
        coingeckoId: 'wrapped-bitcoin'
    },
    HOP: {
        symbol: 'HOP',
        name: 'Hop',
        decimals: 18,
        image: assets_1.HOPImage,
        coingeckoId: 'hop-protocol'
    },
    OP: {
        symbol: 'OP',
        name: 'Optimism',
        decimals: 18,
        image: assets_1.OPImage,
        coingeckoId: 'optimism'
    },
    SNX: {
        symbol: 'SNX',
        name: 'Synthetix Network Token',
        decimals: 18,
        image: assets_1.SNXImage,
        coingeckoId: 'havven'
    },
    sUSD: {
        symbol: 'sUSD',
        name: 'Synth sUSD',
        decimals: 18,
        image: assets_1.sUSDImage,
        coingeckoId: 'nusd'
    },
    GNO: {
        symbol: 'GNO',
        name: 'Gnosis',
        decimals: 18,
        image: assets_1.GNOImage,
        coingeckoId: 'gnosis'
    },
    rETH: {
        symbol: 'rETH',
        name: 'Rocket Pool ETH',
        decimals: 18,
        image: assets_1.rETHImage,
        coingeckoId: 'rocket-pool-eth'
    },
    UNI: {
        symbol: 'UNI',
        name: 'Uniswap',
        decimals: 18,
        image: assets_1.UNIImage,
        coingeckoId: 'uniswap'
    },
    RPL: {
        symbol: 'RPL',
        name: 'Rocket Pool Protocol',
        decimals: 18,
        image: assets_1.RPLImage,
        coingeckoId: 'rocket-pool'
    },
    MAGIC: {
        symbol: 'MAGIC',
        name: 'MAGIC',
        decimals: 18,
        image: assets_1.MAGICImage,
        coingeckoId: 'magic'
    }
    /*
    FRAX: {
      symbol: 'FRAX',
      name: 'Frax',
      decimals: 18,
      image: FraxImage,
      coingeckoId: 'frax'
    }
    */
};
